import logo from './logo.svg';
import './App.css';

function App() {
  const jwtToken = localStorage.getItem('salty_jwt_token'); // Retrieve JWT token from local storage

  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Hello World
        </p>
        <p>
          JWT Token: {jwtToken ? jwtToken : "No token found"}
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>
    </div>
  );
}

export default App;
